<template>
  <Selector
    v-if="analyticsOverviewData"
    class="analytics-service-selector"
    required
    key="analytics-service-selector"
    title="Выберите площадку"
    isMulti
    showSelectAll
    limitOptionsHeight
    style="--options-container-max-height: 40rem"
    :options="serviceOptions"
    :value="selectedServices"
    :select-fitrst-item="false"
    @onChange="debouncedHandleSelectorChange"
  />
</template>

<script>
import Selector from '@/components/sort/Selector';
import { ServiceType, getServiceName } from '@/utils/services';
import { AnalyticsType } from '@/utils/common';
import { debounce } from '@/utils/helpers';

export default {
  name: 'AnalyticsServiceSelector',
  components: {
    Selector,
  },
  data() {
    return {
      ServiceType,
      // debouncedFetchAnalytics: null,
      debouncedHandleSelectorChange: null,
    };
  },
  created() {
    // this.debouncedFetchAnalytics = debounce(this.fetchAnalytics, 1000);
    this.debouncedHandleSelectorChange = debounce(this.handleSelectorChange, 1000);
  },
  computed: {
    activeAccount() {
      return this.$store.state.Auth.activeAccount;
    },
    selectedServices() {
      return [...this.$store.state.Analytics[AnalyticsType.ADVANCED].selectedServices];
    },
    analyticsOverviewData() {
      return this.$store.state.Analytics[AnalyticsType.OVERVIEW].data;
    },
    serviceOptions() {
      return Object.keys(this.analyticsOverviewData)
        .filter((serviceKey) => !!this.analyticsOverviewData[serviceKey].length)
        .map((serviceKey) => ({
          id: serviceKey,
          name: getServiceName(serviceKey),
        }));
    },
  },
  methods: {
    async fetchAnalytics() {
      try {
        this.$store.commit('Analytics/toggleLoading', {
          value: true,
          type: AnalyticsType.ADVANCED,
        });
        await this.$store.dispatch('Analytics/getAdvancedAnalytics', this.activeAccount.id);
      } catch (e) {
        console.error('Failed to fetch analytics:', e);
      } finally {
        this.$store.commit('Analytics/toggleLoading', {
          value: false,
          type: AnalyticsType.ADVANCED,
        });
      }
    },
    async handleSelectorChange(services) {
      this.$store.commit('Analytics/changeSelectedAccounts', []);
      this.$store.commit('Analytics/changeSelectedCompanies', []);
      this.$store.commit('Analytics/changeSelectedServices', [...services]);
      this.$store.commit('Analytics/resetPreviousStepData');

      await this.fetchAnalytics();
    },
  },
};
</script>
